module.exports = __webpack_public_path__ + "static/media/black-november.33b9be96.svg";